import solver from "./sudoku-solver";
import checker from "./sudoku-checker";
import * as _ from "lodash";

function genRandomIdx() {
  // generate random row & col idx from 0-8
  const rowIdx = Math.ceil(Math.random() * 9) - 1;
  const colIdx = Math.ceil(Math.random() * 9) - 1;

  return { row: rowIdx, col: colIdx };
}

function removeRandVal(grid) {
  // remove a value by replacing it with 0

  let currentVal;
  let repeat = true;
  // repeat until find a non-zero value to remove
  while (repeat) {
    const randIdx = genRandomIdx();
    currentVal = grid[randIdx.row][randIdx.col];
    if (currentVal !== 0) {
      grid[randIdx.row][randIdx.col] = 0;
      repeat = false;
    }
  }
}

export default function generator(valsToRemove = 30) {
  // initialize 9x9 array of zeroes
  let grid = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
  ];
  // create a randomized puzzle
  solver(grid);
  let solvable = true;
  let gridCopyMain;
  let gridCopyTest;
  let i = 0;
  while (solvable & (i < valsToRemove)) {
    i++;
    // need 2 copies because solver modifies by reference
    gridCopyMain = _.cloneDeep(grid);
    gridCopyTest = _.cloneDeep(grid);

    removeRandVal(gridCopyMain);
    removeRandVal(gridCopyTest);

    // keep track of missing values after solve attempt
    const numErrorsAfterSolveAttempt = { errors: 0 };
    solver(gridCopyTest, numErrorsAfterSolveAttempt);

    if (numErrorsAfterSolveAttempt.errors !== 0) {
      // unsolvable, so break out of loop
      // and don't assign to grid
      solvable = false;
      break;
    }
    grid = gridCopyMain;
  }

  return grid;
}
